import { Alert, Box, Snackbar, styled } from "@mui/material";

export const MobileIndicatorsSnackbar = styled(Snackbar)(({}) => ({
  zIndex: 11,
  minHeight: "100px",
  "&.MuiSnackbar-root": {
    position: "absolute",
    width: "65%",
    left: 0,
    maxWidth: "320px",
  },
  "& .MuiPaper-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const MobileIndicatorsAlert = styled(Alert)(({}) => ({
  height: "100%",
  boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.4)",
  backgroundColor: "black",
  color: "#ffffff",
  "& .MuiAlert-action": {
    padding: "0px",
  },
}));

export const RotatePhoneAnimationWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const SwipeHandAnimationWrapper = styled(Box)(() => ({
  position: "absolute",
  width: "100vw",
  height: "100vh",
  top: 0,
  left: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 11,
  pointerEvents: "none",
}));

export const UserSwipeOverlay = styled(Box)(() => ({
  width: "100%",
  height: "100vh",
  backgroundColor: "transparent",
  position: "absolute",
  touchAction: "none",
}));
